import { render, staticRenderFns } from "./ProfileLinks.vue?vue&type=template&id=63835684"
import script from "./ProfileLinks.vue?vue&type=script&lang=js"
export * from "./ProfileLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports